export default {
  DP_SPARKOW_CORA_PRO_CODE: 'NW-13260-corapro',
  DP_SPARKOW_CORA_PRO_STANDARD_VALUE: 'NW-13260-corapro~0',
  SEARCH_SPARKOW_CORA_PRO_CODE: 'CORAPRO',
  SEARCH_SPARKOW_CORA_PRO_STANDARD_VALUE: 'skus.corapro=false'
}
